import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "welcome-dialog",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "welcome-dialog-title"
}
const _hoisted_2 = { class: "welcome-dialog__panel" }
const _hoisted_3 = {
  key: 0,
  class: "welcome-dialog__body"
}
const _hoisted_4 = {
  id: "welcome-dialog-title",
  class: "welcome-dialog__title"
}
const _hoisted_5 = {
  class: "welcome-dialog__grid",
  role: "listbox",
  "aria-label": "شخصیت‌ها"
}
const _hoisted_6 = ["aria-selected", "title", "disabled", "onClick"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 0,
  class: "welcome-dialog__error"
}
const _hoisted_9 = { class: "welcome-dialog__actions" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  class: "welcome-dialog__body welcome-dialog__body--tour"
}

import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { updateMe } from "@/api/users";
import { useAuth } from "@/composables/useAuth";
import BrandLogo from "@/components/BrandLogo.vue";
import { COCO_AVATARS } from "@/constants/avatars";
import { handleError } from "@/services/errorHandler";

/** Flip to true when welcome-dialog tour slides are implemented. */
const TOUR_ENABLED = false;


export default /*@__PURE__*/_defineComponent({
  __name: 'WelcomeOnboardingDialog',
  setup(__props) {

const route = useRoute();
const { user, fetchCurrentUser } = useAuth();
const avatars = COCO_AVATARS;

const dismissed = ref(false);
const selectedId = ref<string | null>(null);
const saving = ref(false);
const errorMessage = ref("");
const step = ref<"character" | "tour">("character");

const greeting = computed(() => {
  const name = user.value?.full_name?.trim();
  if (name) return `${name}، خوش آمدی`;
  const handle = typeof user.value?.username === "string" ? user.value.username : "";
  if (handle) return `@${handle}، خوش آمدی`;
  return "خوش آمدی";
});

const open = computed(() => {
  if (dismissed.value) return false;
  if (route.meta.public === true) return false;
  if (!user.value?.id) return false;
  if (user.value.avatar_url) return false;
  return true;
});

watch(open, (isOpen) => {
  document.body.style.overflow = isOpen ? "hidden" : "";
  if (isOpen) {
    step.value = "character";
    selectedId.value = null;
    errorMessage.value = "";
  }
});

async function confirmCharacter() {
  if (!selectedId.value || saving.value) return;
  saving.value = true;
  errorMessage.value = "";
  try {
    await updateMe({ avatar_url: selectedId.value });
    await fetchCurrentUser();
    if (TOUR_ENABLED) {
      step.value = "tour";
    } else {
      finish();
    }
  } catch (e) {
    errorMessage.value = handleError(e, "WelcomeOnboardingDialog.confirmCharacter");
  } finally {
    saving.value = false;
  }
}

function skipForNow() {
  dismissed.value = true;
}

function finish() {
  dismissed.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (open.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "welcome-dialog__backdrop" }, null, -1)),
          _createElementVNode("div", _hoisted_2, [
            (step.value === 'character')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(BrandLogo, {
                    size: "sm",
                    class: "welcome-dialog__logo"
                  }),
                  _cache[0] || (_cache[0] = _createElementVNode("p", { class: "welcome-dialog__eyebrow" }, "اولین ورود", -1)),
                  _createElementVNode("h2", _hoisted_4, _toDisplayString(greeting.value), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("p", { class: "welcome-dialog__lead" }, " به کوکونی خوش آمدی. شخصیتت را انتخاب کن تا در پروفایل و جامعه یادگیری دیده شود. بعداً همین‌جا یک تور کوتاه از سایت اضافه می‌شود. ", -1)),
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(avatars), (avatar) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: avatar.id,
                        type: "button",
                        class: _normalizeClass(["welcome-dialog__option", { 'welcome-dialog__option--active': selectedId.value === avatar.id }]),
                        "aria-selected": selectedId.value === avatar.id,
                        title: avatar.label,
                        disabled: saving.value,
                        onClick: ($event: any) => (selectedId.value = avatar.id)
                      }, [
                        _createElementVNode("img", {
                          src: avatar.src,
                          alt: avatar.label
                        }, null, 8, _hoisted_7)
                      ], 10, _hoisted_6))
                    }), 128))
                  ]),
                  (errorMessage.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errorMessage.value), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "welcome-dialog__primary",
                      disabled: !selectedId.value || saving.value,
                      onClick: confirmCharacter
                    }, _toDisplayString(saving.value ? "در حال ذخیره..." : "ادامه"), 9, _hoisted_10),
                    _createElementVNode("button", {
                      type: "button",
                      class: "welcome-dialog__ghost",
                      disabled: saving.value,
                      onClick: skipForNow
                    }, " بعداً انتخاب می‌کنم ", 8, _hoisted_11)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[2] || (_cache[2] = _createElementVNode("h2", {
                    id: "welcome-dialog-title",
                    class: "welcome-dialog__title"
                  }, "آشنایی با کوکونی", -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("p", { class: "welcome-dialog__lead" }, " تور آموزشی سایت به‌زودی در این مرحله نمایش داده می‌شود. ", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "welcome-dialog__primary",
                    onClick: finish
                  }, " شروع کنیم ")
                ]))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})